import { getDomainConfig } from '@/config/domains/domainConfig'

export const getSupportedCountries = (): string[] => {
  const domainConfig = getDomainConfig()

  const countries = new Set<string>()

  for (const domain in domainConfig) {
    for (const config of domainConfig[domain].configurations) {
      countries.add(config.country)
    }
  }

  return Array.from(countries)
}